import React from 'react';

// Import all images
const images = [
  // 28 Non-food images (indices 0-27)
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.58.02.jpeg'), // 0
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.58.00.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.59 (2).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.59 (1).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.59.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.58.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.57 (2).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.57 (1).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.57.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.56 (1).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 13.57.56.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.09.25.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.09.28.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.15.49.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.15.49 (1).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.24.04.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.24.07.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.24.10.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 14.24.13.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 15.40.12 (1).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 15.40.12.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 15.40.13 (1).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 15.40.13.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 15.40.14.jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 15.40.13 (2).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 15.40.14 (1).jpeg'),
  require('../assets/images/images/WhatsApp Image 2568-03-29 at 16.16.53.jpeg'), // 27
  
  // 23 Food images (indices 28-50)
  require('../assets/images/food/A Mok Fish.jpeg'),                     // 28
  require('../assets/images/food/Chicken hot dry.jpeg'),                // 29
  require('../assets/images/food/Fried beef hot.jpeg'),                 // 30
  require('../assets/images/food/Fried beef mix.jpeg'),                 // 31
  require('../assets/images/food/Fried chicken ginger.jpeg'),           // 32
  require('../assets/images/food/Fried chicken hot.jpeg'),              // 33
  require('../assets/images/food/Fried Corn with Dried Shrimps.jpeg'),  // 34
  require('../assets/images/food/Fried eels hot.jpeg'),                 // 35
  require('../assets/images/food/Fried eels mix.jpeg'),                 // 36
  require('../assets/images/food/Fried mixed vegetable.jpeg'),          // 37
  require('../assets/images/food/Fried noodle.jpeg'),                   // 38
  require('../assets/images/food/Fried rice with shrimps.jpeg'),        // 39
  require('../assets/images/food/Fried seafood pepper.jpeg'),           // 40
  require('../assets/images/food/Fried squid and pepper.jpeg'),         // 41
  require('../assets/images/food/Fry beef sesame.jpeg'),                // 42
  require('../assets/images/food/grilled meat.jpeg'),                   // 43
  require('../assets/images/food/Lok Lak.jpeg'),                        // 44
  require('../assets/images/food/red curry.jpeg'),                      // 45
  require('../assets/images/food/Sour Soup Lemongrass.jpeg'),           // 46
  require('../assets/images/food/Sour soup cambodia.jpeg'),             // 47
  require('../assets/images/food/Sour soup stir.jpeg'),                 // 48
  require('../assets/images/food/Sour soup vietnamese.jpeg'),           // 49
  require('../assets/images/food/Stir fry meat with vegetable.jpeg'),   // 50
];

// Hardcoded aantal non-food images
const NON_FOOD_IMAGE_COUNT = 28; 

// Lijst van exacte food bestandsnamen (23 items)
export const FOOD_IMAGE_FILENAMES = [
  'A Mok Fish.jpeg',
  'Chicken hot dry.jpeg',
  'Fried beef hot.jpeg',
  'Fried beef mix.jpeg',
  'Fried chicken ginger.jpeg',
  'Fried chicken hot.jpeg',
  'Fried Corn with Dried Shrimps.jpeg',
  'Fried eels hot.jpeg',
  'Fried eels mix.jpeg',
  'Fried mixed vegetable.jpeg',
  'Fried noodle.jpeg',
  'Fried rice with shrimps.jpeg',
  'Fried seafood pepper.jpeg',
  'Fried squid and pepper.jpeg',
  'Fry beef sesame.jpeg',
  'grilled meat.jpeg',
  'Lok Lak.jpeg',
  'red curry.jpeg',
  'Sour Soup Lemongrass.jpeg',
  'Sour soup cambodia.jpeg',
  'Sour soup stir.jpeg',
  'Sour soup vietnamese.jpeg',
  'Stir fry meat with vegetable.jpeg',
];

interface ImageLoaderProps {
  index?: number; 
  alt: string;
  className?: string;
  fileName?: string; 
}

const ImageLoader: React.FC<ImageLoaderProps> = ({ index, alt, className = '', fileName }) => {
  let safeIndex: number = -1; 

  if (fileName) {
    const fileIndex = FOOD_IMAGE_FILENAMES.findIndex(f => f === fileName);
    if (fileIndex !== -1) {
      // Bereken index gebaseerd op positie in food array + aantal non-food items
      safeIndex = NON_FOOD_IMAGE_COUNT + fileIndex; 
    } else {
      console.error(`ImageLoader: File name ${fileName} not found in FOOD_IMAGE_FILENAMES.`);
      return <div className={`bg-gray-200 ${className} ...`}>File Not Found: {fileName}</div>; 
    }
  } else if (index !== undefined && index >= 0) {
    // Gebruik index direct (voor non-food images)
    safeIndex = index % images.length; 
  } else {
    console.error(`ImageLoader: Invalid props...`);
    return <div className={`bg-gray-200 ${className} ...`}>Invalid Props</div>; 
  }

  // Definitieve controle tegen de daadwerkelijke array lengte
  if (safeIndex < 0 || safeIndex >= images.length || !images[safeIndex]) {
    console.error(`ImageLoader: Final check failed. safeIndex=${safeIndex}, images.length=${images.length}, fileName=${fileName || 'N/A'}, index=${index || 'N/A'}`);
    return <div className={`bg-gray-200 ${className} ...`}>Img Err: {fileName || `Index ${index}`}</div>; 
  }

  // Verwijder de vorige debug log
  // console.log(`ImageLoader Debug: ...`); 

  return (
    <img 
      src={images[safeIndex]} 
      alt={alt} 
      className={className} 
      loading="lazy"
      data-index={safeIndex}
      data-filename={fileName || 'N/A'} // Zorg dat dit altijd een string is
      onError={(e) => { 
        console.error(`ImageLoader: Error loading image src...`);
        (e.target as HTMLImageElement).style.display = 'none';
      }}
    />
  );
};

export default ImageLoader; 